(() => {
  const initializeRecipe = (recipe) => {
    if (!recipe || recipe.dataset.mrRecipeReady === 'true') {
      return;
    }

    recipe.dataset.mrRecipeReady = 'true';

    const unitButtons = Array.from(
      recipe.querySelectorAll('[data-mr-unit]')
    );

    const amounts = Array.from(
      recipe.querySelectorAll('[data-mr-amount]')
    );

    const setUnit = (unit) => {
      unitButtons.forEach((button) => {
        const isActive = button.dataset.mrUnit === unit;

        button.classList.toggle('is-active', isActive);
        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });

      amounts.forEach((amount) => {
        const requestedAmount = amount.dataset[unit] || '';
        const fallbackUnit = unit === 'oz' ? 'ml' : 'oz';
        const fallbackAmount =
          amount.dataset[fallbackUnit] || '';

        if (requestedAmount) {
          amount.textContent =
            `${requestedAmount} ${unit.toUpperCase()}`;
          amount.hidden = false;
          return;
        }

        if (fallbackAmount) {
          amount.textContent =
            `${fallbackAmount} ${fallbackUnit.toUpperCase()}`;
          amount.hidden = false;
          return;
        }

        amount.textContent = '';
        amount.hidden = true;
      });
    };

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setUnit(button.dataset.mrUnit);
      });
    });

    setUnit(recipe.dataset.defaultUnit || 'oz');

    const copyButton = recipe.querySelector('[data-mr-copy]');
    const copyStatus = recipe.querySelector(
      '[data-mr-copy-status]'
    );

    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const url =
          copyButton.dataset.url || window.location.href;

        try {
          await navigator.clipboard.writeText(url);

          if (copyStatus) {
            copyStatus.textContent = 'Link copied.';
          }
        } catch (error) {
          if (copyStatus) {
            copyStatus.textContent =
              'Please copy the URL from your browser.';
          }
        }
      });
    }
  };

  const initializeAllRecipes = (root = document) => {
    root
      .querySelectorAll('[data-mr-recipe]')
      .forEach(initializeRecipe);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllRecipes();
    });
  } else {
    initializeAllRecipes();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAllRecipes(event.target);
    }
  );
})();
